<div class="height-100 width-100">
  <div class="auth-bg pad-d-10 flex-desk ">
    <div  class="">
      <div class="flex align-c justify-c pos-r min-h">
        <div class="sign-con">
          <div class="sign-card border-c border">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>